<div aria-label="Button group with nested dropdown" class="btn-group" container="body" ngbDropdown role="group">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button (click)="onDeleteTriggerConfiguration()"
      [disabled]="deleteButtonIsDisabled"
      [ngClass]="{'text-danger': !deleteButtonIsDisabled}"
      ngbDropdownItem>
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span></button>

      <button (click)="onEditTriggerConfiguration()" [disabled]="isGapDetectionInProgress[triggerConfiguration.id]"
        ngbDropdownItem>
        <span class="fa-solid fa-pen"></span>
        <span translate>Edit</span>
      </button>

      @if (showActivateTriggerButton) {
        <button (click)="onActivateTriggerConfig()"
          [disabled]="activateButtonIsDisabled" ngbDropdownItem>
          <span class="fa-solid fa-play"></span>
          <span translate>Activate</span>
        </button>
      }

      @if (showDeactivateTriggerButton) {
        <button (click)="onDeactivateTriggerConfig()"
          [disabled]="deactivateButtonIsDisabled" ngbDropdownItem>
          <span class="fa-solid fa-pause"></span>
          <span translate>Deactivate</span>
        </button>
      }

      <button (click)="onForceTriggerExecution()" [disabled]="forceTriggerIsDisabled" ngbDropdownItem>
        <span class="fa-solid fa-bell"></span>
        <span translate>Force execution</span>
      </button>

    </div>
  </div>
